import SliderDropdown from './sliderdropdown'

export default SliderDropdown
